import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const MarketoveSkupinyNd = {
	name: NAME,
	apiProvider,
	router,
};
